export const NameCell = ({ getValue }) => {
  return <div>{getValue()}</div>;
};
